import React from 'react';
import Image from '../../../components/Image/Image';
import * as classes from './Wrapper.module.css';

const Diptych = (props) => {
    const styles = props.classes ? [classes.Diptych, ...props.classes] : [classes.Diptych];

    const caramel = (
        <Image
            imgsrc={props.caramel.image}
            alt={props.caramel.name}
            height='2695px'
            width='1797px'
            className={classes.Image}
        />
    )

    const ingredient = (
        <Image
            imgsrc={props.ingredient.image}
            alt={props.name}
            height='2695px'
            width='1797px'
            className={classes.Image}
        />
    )

    const diptych = (
        <div
            className={styles.join(' ')}
        >
            {ingredient}
            {caramel}
        </div>
    )

    return diptych;
};

export default Diptych;